"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = __importDefault(require("./utils"));
const utils_2 = require("../../../../utils/utils");
/* eslint-disable quotes, max-len */
exports.default = [
    {
        weight: 0,
        input: true,
        label: 'Advanced Logic',
        key: 'logic',
        templates: {
            header: '<div class="row"> \n  <div class="col-sm-6">\n    <strong>{{ value.length }} {{ ctx.t("Advanced Logic Configured") }}</strong>\n  </div>\n</div>',
            row: '<div class="row"> \n  <div class="col-sm-6">\n    <div>{{ row.name }} </div>\n  </div>\n  <div class="col-sm-2"> \n    <div class="btn-group pull-right"> \n      <button class="btn btn-default editRow">{{ ctx.t("Edit") }}</button> \n      <button class="btn btn-danger removeRow">{{ ctx.t("Delete") }}</button> \n    </div> \n  </div> \n</div>',
            footer: '',
        },
        type: 'editgrid',
        addAnother: 'Add Logic',
        saveRow: 'Save Logic',
        components: [
            {
                weight: 0,
                input: true,
                inputType: 'text',
                label: 'Logic Name',
                key: 'name',
                validate: {
                    required: true,
                },
                type: 'textfield',
            },
            {
                weight: 10,
                key: 'triggerPanel',
                input: false,
                title: 'Trigger',
                tableView: false,
                components: [
                    {
                        weight: 0,
                        input: true,
                        tableView: false,
                        components: [
                            {
                                weight: 0,
                                input: true,
                                label: 'Type',
                                key: 'type',
                                tableView: false,
                                data: {
                                    values: [
                                        {
                                            value: 'simple',
                                            label: 'Simple',
                                        },
                                        {
                                            value: 'javascript',
                                            label: 'Javascript',
                                        },
                                        {
                                            value: 'json',
                                            label: 'JSON Logic',
                                        },
                                        {
                                            value: 'event',
                                            label: 'Event',
                                        },
                                        //Simple
                                        {
                                            value: 'internalevent',
                                            label: 'Internal Event',
                                        }
                                        //Simple end
                                    ],
                                },
                                dataSrc: 'values',
                                template: '<span>{{ item.label }}</span>',
                                type: 'select',
                            },
                            {
                                weight: 10,
                                label: '',
                                key: 'simple',
                                type: 'container',
                                tableView: false,
                                customConditional({ row }) {
                                    return row.type === 'simple';
                                },
                                components: [
                                    {
                                        input: true,
                                        key: 'show',
                                        label: 'Show',
                                        type: 'hidden',
                                        tableView: false,
                                        calculateValue() {
                                            return true;
                                        },
                                    },
                                    {
                                        type: 'select',
                                        input: true,
                                        label: 'When the form component:',
                                        key: 'when',
                                        dataSrc: 'custom',
                                        valueProperty: 'value',
                                        tableView: false,
                                        data: {
                                            custom(context) {
                                                return (0, utils_2.getContextComponents)(context);
                                            },
                                        },
                                    },
                                    {
                                        type: 'textfield',
                                        input: true,
                                        label: 'Has the value:',
                                        key: 'eq',
                                        tableView: false,
                                    },
                                ],
                            },
                            {
                                weight: 10,
                                type: 'textarea',
                                key: 'javascript',
                                rows: 5,
                                editor: 'ace',
                                as: 'javascript',
                                input: true,
                                tableView: false,
                                placeholder: `result = (data['mykey'] > 1);`,
                                description: '"row", "data", and "component" variables are available. Return "result".',
                                customConditional({ row }) {
                                    return row.type === 'javascript';
                                },
                            },
                            {
                                weight: 10,
                                type: 'textarea',
                                key: 'json',
                                rows: 5,
                                editor: 'ace',
                                label: 'JSON Logic',
                                as: 'json',
                                input: true,
                                tableView: false,
                                placeholder: `{ ... }`,
                                description: '"row", "data", "component" and "_" variables are available. Return the result to be passed to the action if truthy.',
                                customConditional({ row }) {
                                    return row.type === 'json';
                                },
                            },
                            {
                                weight: 10,
                                type: 'textfield',
                                key: 'event',
                                label: 'Event Name',
                                placeholder: 'event',
                                description: 'The event that will trigger this logic. You can trigger events externally or via a button.',
                                tableView: false,
                                customConditional({ row }) {
                                    return row.type === 'event';
                                },
                            },
                            //Simple
                            {
                                weight: 10,
                                type: 'textfield',
                                key: 'internalevent',
                                label: 'Internal Event Name',
                                placeholder: 'internal event',
                                description: 'The event that will trigger this logic. Using html event eg: blur, change...',
                                tableView: false,
                                customConditional({ row }) {
                                    return row.type === 'internalevent';
                                },
                            }
                            //Simple end
                        ],
                        key: 'trigger',
                        type: 'container',
                    },
                ],
                type: 'panel',
            },
            {
                weight: 20,
                input: true,
                label: 'Actions',
                key: 'actions',
                tableView: false,
                templates: {
                    header: '<div class="row"> \n  <div class="col-sm-6"><strong>{{ value.length }} {{ ctx.t("actions") }}</strong></div>\n</div>',
                    row: '<div class="row"> \n  <div class="col-sm-6">\n    <div>{{ row.name }} </div>\n  </div>\n  <div class="col-sm-2"> \n    <div class="btn-group pull-right"> \n      <button class="btn btn-default editRow">{{ ctx.t("Edit") }}</button> \n      <button class="btn btn-danger removeRow">{{ ctx.t("Delete") }}</button> \n    </div> \n  </div> \n</div>',
                    footer: '',
                },
                type: 'editgrid',
                addAnother: 'Add Action',
                saveRow: 'Save Action',
                components: [
                    {
                        weight: 0,
                        title: 'Action',
                        input: false,
                        key: 'actionPanel',
                        type: 'panel',
                        components: [
                            {
                                weight: 0,
                                input: true,
                                inputType: 'text',
                                label: 'Action Name',
                                key: 'name',
                                validate: {
                                    required: true,
                                },
                                type: 'textfield',
                            },
                            {
                                weight: 10,
                                input: true,
                                label: 'Type',
                                key: 'type',
                                data: {
                                    values: [
                                        {
                                            value: 'property',
                                            label: 'Property',
                                        },
                                        {
                                            value: 'value',
                                            label: 'Value',
                                        },
                                        {
                                            label: 'Merge Component Schema',
                                            value: 'mergeComponentSchema',
                                        },
                                        {
                                            label: 'Custom Action',
                                            value: 'customAction',
                                        },
                                        //Simple
                                        {
                                            label: 'POST to Ari Core',
                                            value: 'aripost',
                                        },
                                        {
                                            label: 'Redirect page',
                                            value: 'swpage',
                                        },
                                        //End Simple
                                    ],
                                },
                                dataSrc: 'values',
                                template: '<span>{{ item.label }}</span>',
                                type: 'select',
                            },
                            {
                                weight: 20,
                                type: 'select',
                                template: '<span>{{ item.label }}</span>',
                                dataSrc: 'json',
                                tableView: false,
                                data: {
                                    json: [
                                        {
                                            label: 'Hidden',
                                            value: 'hidden',
                                            type: 'boolean',
                                        },
                                        {
                                            label: 'Required',
                                            value: 'validate.required',
                                            type: 'boolean',
                                        },
                                        {
                                            label: 'Disabled',
                                            value: 'disabled',
                                            type: 'boolean',
                                        },
                                        {
                                            label: 'Label',
                                            value: 'label',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Title',
                                            value: 'title',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Prefix',
                                            value: 'prefix',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Suffix',
                                            value: 'suffix',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Tooltip',
                                            value: 'tooltip',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Description',
                                            value: 'description',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Placeholder',
                                            value: 'placeholder',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Input Mask',
                                            value: 'inputMask',
                                            type: 'string',
                                        },
                                        {
                                            label: 'CSS Class',
                                            value: 'className',
                                            type: 'string',
                                        },
                                        {
                                            label: 'Container Custom Class',
                                            value: 'customClass',
                                            type: 'string',
                                        },
                                    ],
                                },
                                key: 'property',
                                label: 'Component Property',
                                input: true,
                                customConditional({ row }) {
                                    return row.type === 'property';
                                },
                            },
                            {
                                weight: 30,
                                input: true,
                                label: 'Set State',
                                key: 'state',
                                tableView: false,
                                data: {
                                    values: [
                                        {
                                            label: 'True',
                                            value: 'true',
                                        },
                                        {
                                            label: 'False',
                                            value: 'false',
                                        },
                                    ],
                                },
                                dataSrc: 'values',
                                template: '<span>{{ item.label }}</span>',
                                type: 'select',
                                customConditional({ row }) {
                                    return row.type === 'property' &&
                                        row.hasOwnProperty('property') &&
                                        row.property.type === 'boolean';
                                },
                            },
                            {
                                weight: 30,
                                type: 'textfield',
                                key: 'text',
                                label: 'Text',
                                inputType: 'text',
                                input: true,
                                tableView: false,
                                description: 'Can use templating with {{ data.myfield }}. "data", "row", "component" and "result" variables are available.',
                                customConditional({ row }) {
                                    return row.type === 'property' &&
                                        row.hasOwnProperty('property') &&
                                        row.property.type === 'string' &&
                                        !row.property.component;
                                },
                            },
                            {
                                weight: 20,
                                input: true,
                                label: 'Value (Javascript)',
                                key: 'value',
                                editor: 'ace',
                                as: 'javascript',
                                rows: 5,
                                placeholder: `value = data.myfield;`,
                                type: 'textarea',
                                tableView: false,
                                description: '"row", "data", "component", and "result" variables are available. Return the value.',
                                customConditional({ row }) {
                                    return row.type === 'value';
                                },
                            },
                            {
                                weight: 20,
                                input: true,
                                label: 'Schema Definition',
                                key: 'schemaDefinition',
                                editor: 'ace',
                                as: 'javascript',
                                rows: 5,
                                placeholder: `schema = { label: 'Updated' };`,
                                type: 'textarea',
                                tableView: false,
                                description: '"row", "data", "component", and "result" variables are available. Return the schema.',
                                customConditional({ row }) {
                                    return row.type === 'mergeComponentSchema';
                                },
                            },
                            Object.assign(utils_1.default.logicVariablesTable('<tr><th>input</th><td>The value that was input into this component</td></tr>'), {
                                customConditional({ row }) {
                                    return row.type === 'customAction';
                                }
                            }),
                            {
                                weight: 20,
                                input: true,
                                label: 'Custom Action (Javascript)',
                                key: 'customAction',
                                editor: 'ace',
                                rows: 5,
                                placeholder: `value = data.myfield;`,
                                type: 'textarea',
                                tableView: false,
                                customConditional({ row }) {
                                    return row.type === 'customAction';
                                },
                            },
                            //Simple
                            {
                                type: 'textfield',
                                inputType: 'url',
                                key: 'ariaction',
                                input: true,
                                weight: 120,
                                label: 'Ari Action',
                                tooltip: 'The API path that not included domain and API version.',
                                placeholder: 'bo/bank/list',
                                customConditional({ row }) {
                                    return row.type === 'aripost';
                                },
                            },
                            {
                                type: 'select',
                                key: 'resultType',
                                label: 'Show toast for result',
                                input: true,
                                dataSrc: 'values',
                                weight: 110,
                                tooltip: 'Show toast',
                                data: {
                                    values: [
                                        { label: 'None', value: 'none' },
                                        { label: 'Top right', value: 'toast-top-right' },
                                        { label: 'Bottom Right', value: 'toast-bottom-right' },
                                        { label: 'Bottom Left', value: 'toast-bottom-left' },
                                        { label: 'Top Left', value: 'toast-top-left' },
                                        { label: 'Top Full Width', value: 'toast-top-full-width' },
                                        { label: 'Bottom Full Width', value: 'toast-bottom-full-width' },
                                        { label: 'Top Center', value: 'toast-top-center' },
                                        { label: 'Bottom Center', value: 'toast-bottom-center' },
                                    ],
                                },
                                customConditional({ row }) {
                                    return row.type === 'aripost';
                                },
                            },
                            //simple
                            {
                                type: 'datagrid',
                                key: 'aribody',
                                input: true,
                                weight: 130,
                                label: 'Request message body',
                                addAnother: 'Add Node',
                                tooltip: 'JSON body message structure',
                                components: [
                                    {
                                        key: 'path',
                                        label: 'Path',
                                        input: true,
                                        type: 'textfield',
                                    },
                                    {
                                        type: 'select',
                                        key: 'type',
                                        label: 'Type',
                                        input: true,
                                        dataSrc: 'values',
                                        data: {
                                            values: [
                                                { label: 'Value', value: 'value' },
                                                { label: 'Data', value: 'data' },
                                                { label: 'Script', value: 'script' },
                                            ],
                                        },
                                        defaultValue: 'data'
                                    },
                                    {
                                        key: 'value',
                                        label: 'Value',
                                        input: true,
                                        //rows: 3,
                                        //editor: 'ace',
                                        as: 'javascript',
                                        type: 'textarea',
                                        attributes: {
                                            style: 'height:calc(1.5em + .75rem + 2px)',
                                        },
                                        placeholder: '',
                                    }
                                ],
                                customConditional({ row }) {
                                    return row.type === 'aripost';
                                },
                            },
                            {
                                type: 'textarea',
                                key: 'ariOnSucess',
                                label: 'Handle success response',
                                tooltip: 'Javascript code logic to handle response',
                                rows: 5,
                                editor: 'ace',
                                input: true,
                                weight: 131,
                                placeholder: 'your javascript code',
                                customConditional({ row }) {
                                    return row.type === 'aripost';
                                },
                            },
                            {
                                type: 'textarea',
                                key: 'ariOnFail',
                                label: 'Handle fail response',
                                tooltip: 'Javascript code logic to handle response',
                                rows: 5,
                                editor: 'ace',
                                input: true,
                                weight: 132,
                                placeholder: 'your javascript code',
                                customConditional({ row }) {
                                    return row.type === 'aripost';
                                },
                            },
                            {
                                type: 'datagrid',
                                key: 'swpageParamGet',
                                input: true,
                                weight: 130,
                                label: 'Url Params',
                                addAnother: 'Add Param',
                                tooltip: 'Param Query (URL)',
                                components: [
                                    {
                                        key: 'key',
                                        label: 'Key',
                                        input: true,
                                        type: 'textfield',
                                    },
                                    {
                                        type: 'select',
                                        key: 'type',
                                        label: 'Type',
                                        input: true,
                                        dataSrc: 'values',
                                        data: {
                                            values: [
                                                { label: 'Value', value: 'value' },
                                                { label: 'Data', value: 'data' },
                                                { label: 'Script', value: 'script' },
                                            ],
                                        },
                                        defaultValue: 'data'
                                    },
                                    {
                                        key: 'value',
                                        label: 'Value',
                                        input: true,
                                        //rows: 3,
                                        //editor: 'ace',
                                        as: 'javascript',
                                        type: 'textarea',
                                        attributes: {
                                            style: 'height:calc(1.5em + .75rem + 2px)',
                                        },
                                        placeholder: '',
                                    }
                                ],
                                customConditional({ row }) {
                                    return row.type === 'swpage';
                                },
                            },
                            {
                                type: 'datagrid',
                                key: 'swpageParamPost',
                                input: true,
                                weight: 130,
                                label: 'Params in SessionStorage',
                                addAnother: 'Add Param',
                                tooltip: 'Session Param',
                                components: [
                                    {
                                        key: 'key',
                                        label: 'Key',
                                        input: true,
                                        type: 'textfield',
                                    },
                                    {
                                        type: 'select',
                                        key: 'type',
                                        label: 'Type',
                                        input: true,
                                        dataSrc: 'values',
                                        data: {
                                            values: [
                                                { label: 'Value', value: 'value' },
                                                { label: 'Data', value: 'data' },
                                                { label: 'Script', value: 'script' },
                                            ],
                                        },
                                        defaultValue: 'data'
                                    },
                                    {
                                        key: 'value',
                                        label: 'Value',
                                        input: true,
                                        //rows: 3,
                                        //editor: 'ace',
                                        as: 'javascript',
                                        type: 'textarea',
                                        attributes: {
                                            style: 'height:calc(1.5em + .75rem + 2px)',
                                        },
                                        placeholder: '',
                                    }
                                ],
                                customConditional({ row }) {
                                    return row.type === 'swpage';
                                },
                            },
                            {
                                type: 'checkbox',
                                key: 'openNewTab',
                                label: 'Open New Tab',
                                input: true,
                                weight: 155,
                                tooltip: 'Open link in new tab',
                                customConditional({ row }) {
                                    return row.type === 'swpage';
                                },
                            },
                            //End Simple
                        ],
                    },
                ],
            },
        ],
    },
];
/* eslint-enable quotes, max-len */
